'use es6';

import { REHYDRATE_FROM_USER_SETTINGS } from 'EmailData/actions/actionTypes';
import { DISMISS_SIDEBAR_TOOLS_CAROUSEL } from 'email-management-lib/refactor/actions/actionTypes';
const INITIAL_STATE = false;
export default function dismissedToolsSidebarCarousel(state = INITIAL_STATE, action) {
  switch (action.type) {
    case REHYDRATE_FROM_USER_SETTINGS:
      if (action.payload.has('dismissedToolsSidebarCarousel')) {
        return action.payload.get('dismissedToolsSidebarCarousel');
      }
      return state;
    case DISMISS_SIDEBAR_TOOLS_CAROUSEL:
      return true;
    default:
      return state;
  }
}